import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Markdown from 'src/utils/markdownToComponent';
import { Grid } from '@material-ui/core';
import { textBold, colors } from 'styles';
import { breakpoint } from 'src/utils/mediaQueries';
import Img from 'gatsby-image';

const ContentBlock = styled(Grid)`
  position: relative;
  ${breakpoint.down('md')`flex-direction:row;justify-content:unset;`}
  &:not(:last-child):before {
    position: absolute;
    top: 42%;
    left: 50%;
    content: '';
    width: 66%;
    height: 1px;
    background-color: ${colors.grey};
    ${breakpoint.down('md', 'sm')`width:1px;height:66%;top:50%;`}
    ${breakpoint.down('md')`left:175px;`}
    ${breakpoint.down('sm')`left:95px;`}
    ${breakpoint.only('xxs')`top: 60%;left:80px;`}
  }
`;
const ContentImage = styled(Grid)`
  flex: 1 0 auto;
  align-self: center;
  max-width: 300px;
  ${breakpoint.only('xs')`max-width:150px;`}
  ${breakpoint.only('xxs')`max-width:110px;`}
`;
const StyledMarkdown = styled(Markdown)`
  ${textBold};
  text-align: center;
  //text-transform: uppercase;
  font-size: ${props => `${props.theme.typography.subtitle2.fontSize}px`};
  ${breakpoint.down(
    'md'
  )`display:flex; align-items:center;align-content:center;text-align:left;padding-left:1rem;flex: 1 0 auto;font-size: ${props => `${
    props.theme.typography.body2.fontSize
  }
px`};`}
  ${breakpoint.only('xxs')`
    font-size: ${props => `${props.theme.typography.caption.fontSize}
px`};`};
`;

const OperationBlock = ({ data, image, lang }) => {
  const [imageToShow, setImageToShow] = useState();
  useEffect(() => {
    import(`images/indexPage/operationBlock/${lang}/${image.base}`).then(img => {
      setImageToShow(img.default);
    })
  }, [image])
  const NonStretchedImage = () => {
    let normalizedProps = image.childImageSharp;
    if (
      image.childImageSharp &&
      image.childImageSharp.fluid &&
      image.childImageSharp.fluid.presentationWidth &&
      normalizedProps
    ) {
      normalizedProps = {
        ...image.childImageSharp,
        style: {
          ...(image.childImageSharp.style || {}),
          maxWidth: image.childImageSharp.fluid.presentationWidth,
          margin: '0 auto', // Used to center the image
          flexGrow: '1',
        },
      };
    }
    if (normalizedProps) {
      return <Img {...normalizedProps} loading="lazy" />
    } else {
     return <img src={imageToShow} style={{maxWidth: 275, flexGrow: "1", margin: "0 auto", zIndex: 3}} loading="lazy" />
    }
  };
  return (
    <ContentBlock
      container
      direction="column"
      item
      xs={12}
      sm={10}
      md={4}
      lg={4}
    >
      <ContentImage container alignItems="center" alignContent="center">
        {NonStretchedImage()}
      </ContentImage>
      <StyledMarkdown>{data.rawMarkdownBody}</StyledMarkdown>
    </ContentBlock>
  );
};

export default OperationBlock;
